/** CoStar.Api.ConsumerUserData.Alerts.AlertFrequencyType */
export var AlertFrequencyType;
(function (AlertFrequencyType) {
    AlertFrequencyType[AlertFrequencyType["None"] = 0] = "None";
    AlertFrequencyType[AlertFrequencyType["Immediately"] = 1] = "Immediately";
    AlertFrequencyType[AlertFrequencyType["Daily"] = 2] = "Daily";
    AlertFrequencyType[AlertFrequencyType["Weekly"] = 3] = "Weekly";
    AlertFrequencyType[AlertFrequencyType["Never"] = 4] = "Never";
})(AlertFrequencyType || (AlertFrequencyType = {}));
/** CoStar.Api.ConsumerUserData.Alerts.AlertCategoryType */
export var AlertCategoryType;
(function (AlertCategoryType) {
    AlertCategoryType[AlertCategoryType["None"] = 0] = "None";
    AlertCategoryType[AlertCategoryType["SavedSearch"] = 1] = "SavedSearch";
    AlertCategoryType[AlertCategoryType["Favorite"] = 2] = "Favorite";
})(AlertCategoryType || (AlertCategoryType = {}));
/** CoStar.Api.ConsumerUserData.Alerts.AlertDeliveryType */
export var AlertDeliveryType;
(function (AlertDeliveryType) {
    AlertDeliveryType[AlertDeliveryType["None"] = 0] = "None";
    AlertDeliveryType[AlertDeliveryType["Email"] = 1] = "Email";
    AlertDeliveryType[AlertDeliveryType["ShortMessageSystem"] = 2] = "ShortMessageSystem";
    AlertDeliveryType[AlertDeliveryType["Push"] = 3] = "Push";
})(AlertDeliveryType || (AlertDeliveryType = {}));
/** CoStar.Api.ConsumerUserData.Alerts.AlertCategoryEntityType */
export var AlertCategoryEntityType;
(function (AlertCategoryEntityType) {
    AlertCategoryEntityType[AlertCategoryEntityType["None"] = 0] = "None";
    AlertCategoryEntityType[AlertCategoryEntityType["SavedSearch"] = 1] = "SavedSearch";
    AlertCategoryEntityType[AlertCategoryEntityType["Favorite"] = 2] = "Favorite";
})(AlertCategoryEntityType || (AlertCategoryEntityType = {}));
